export default __webpack_public_path__ + "static/media/Snd_LowerIDot.3bd0ec50.mp3";